//src/services/groups.ts
import { api } from "@/lib/apiClient";

export type GroupScope = "platform" | "tenant" | "client";

export type GroupListItem = {
  id: string;
  name: string;
  description?: string | null;
  scope: GroupScope;
  is_active: boolean;
  user_count: number;
  permission_count: number;
};

export type GroupDetailOut = GroupListItem & {
  tenant_id: string;
  permission_ids: string[];
  permissions: string[];
};

export type GroupUpsertIn = {
  name: string;
  description?: string | null;
  scope: GroupScope;
  is_active: boolean;
};

export type GroupStatusPatchIn = { is_active: boolean };
export type GroupPermissionsUpdateIn = { permission_ids: string[] };

export type PermissionListItem = {
  id: string;
  code: string;
  description?: string | null;
  scope: GroupScope;
};

export async function listGroups(includeInactive = false, scope?: GroupScope) {
  return api.get<GroupListItem[]>("/groups", {
    params: {
      ...(includeInactive ? { include_inactive: true } : {}),
      ...(scope ? { scope } : {}),
    },
  });
}

export async function getGroupDetail(groupId: string) {
  return api.get<GroupDetailOut>(`/groups/${groupId}`);
}

export async function createGroup(payload: GroupUpsertIn) {
  return api.post<{ id: string }>("/groups", payload);
}

export async function updateGroup(groupId: string, payload: GroupUpsertIn) {
  return api.put<{ id: string }>(`/groups/${groupId}`, payload);
}

export async function patchGroupStatus(groupId: string, payload: GroupStatusPatchIn) {
  return api.patch<{ id: string }>(`/groups/${groupId}`, payload);
}

export async function deleteGroup(groupId: string) {
  return api.delete<{ id: string }>(`/groups/${groupId}`);
}

export async function listPermissions(scope: GroupScope) {
  return api.get<PermissionListItem[]>("/permissions", { params: { scope } });
}

export async function updateGroupPermissions(groupId: string, payload: GroupPermissionsUpdateIn) {
  return api.put<{ id: string }>(`/groups/${groupId}/permissions`, payload);
}
